import styles from './CampaignGrid.module.css';

/**
 * 체험단 카드 그리드.
 * 같은 열 수·간격 정의가 목록 페이지와 홈 섹션에 복제돼 있어
 * 열 수를 바꿀 때마다 두 파일을 고쳐야 했다.
 */
export default function CampaignGrid({ children }) {
  return <div className={styles.grid}>{children}</div>;
}
